import { axiosInstance } from "./apiConfig"

export const apiUpdateBookingRestaurant = async ({
    storeId,
    bookingCode,
    newStoreName,
    VisitDate,
    VisitTime,
    SpecialRequests,
    PromotionId,
    PartySize,
    name,
    surname,
    mobilePhone,
    email,
    mobilePhoneCountryCode,
    receiveEmailMarketing = false,
    emailMarketingOptInText = '',
}) => {
    const response = await axiosInstance.post(
        `/thirdparty/resdiary/store/${storeId}/booking/${bookingCode}/updateRestaurant`,
        `VisitDate=${VisitDate}&VisitTime=${VisitTime}&PartySize=${PartySize}` +
        `&NewRestaurantMicrositeName=${newStoreName}` +
        `&Customer[FirstName]=${name}&Customer[Surname]=${surname}` +
        `&Customer[MobileCountryCode]=${mobilePhoneCountryCode}` +
        `&Customer[Mobile]=${mobilePhone}` +
        `&SpecialRequests=${SpecialRequests}` +
        `&PromotionId=${PromotionId || null}` +
        `&Customer[Email]=${email}` +
        `&IsLeaveTimeConfirmed=false` +
        `&Customer[ReceiveEmailMarketing]=${receiveEmailMarketing}` +
        `&Customer[ReceiveRestaurantEmailMarketing]=${receiveEmailMarketing}` +
        `&Customer[GroupEmailMarketingOptInText]=${emailMarketingOptInText}` +
        `&Customer[RestaurantEmailMarketingOptInText]=${emailMarketingOptInText}`,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
    );
    return response.data;
}


// WEBPACK FOOTER //
// ./src/api/apiUpdateBookingRestaurant.js